<template>
  <!-- 应收款明细表 （分摊费用管理）-->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="list_add">分摊计算</el-button>
           <el-button @click="logs">查看日记</el-button>
           <el-button @click="sums">查看汇总</el-button>
           <el-button @click="add">新增</el-button>
           <el-button @click="updateDate">修改计费时间</el-button>
           <el-button @click="dels">删除</el-button>
           <el-button @click="lise_del">全部删除</el-button>
         </div>
         <div class="cdj_div">查询条件-<span v-if="search">{{search}}</span><span v-else>所有房产</span></div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">收费项目</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeItem_name_id"
                       style="width: 100%"
                       clearable
                       @change="chargeItem_names"
                       size="mini"
                       placeholder="收费项目">
                       <el-option
                         v-for="item in chargeitem_1"
                         :key="item.id"
                         :label="item.chargeItem_name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">客户名称</div>
                 <div class="cdj_el-input">
                     <el-input size="mini" v-model="data.name"></el-input>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">计费周期</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-date-picker size="mini" v-model="startDate" type="date" placeholder="开始时间"></el-date-picker>
                   <span class="cdj_text_data">至</span>
                   <el-date-picker size="mini" v-model="endDate" type="date" placeholder="结束时间"></el-date-picker>
                 </div>
               </div>
             </div>
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">收费标准</div>
                   <el-select
                       v-model="data.chargeitemID"
                       class="cdj_el-input"
                       size="mini"
                       clearable
                       placeholder="收费标准">
                       <el-option
                         v-for="item in charge"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">审核标记</div>
                 <div class="cdj_el-input" style="margin-top: 2px;">
                   <el-radio v-model="data.IsCheck" label="1">未审核</el-radio>
                   <el-radio v-model="data.IsCheck" label="2" disabled>已审核</el-radio>
                 </div>
               </div>
              <div class="cdj_left_display cdj_top">
                <div class="cdj_left_display_background">说明</div>
                <div class="cdj_el-input" style="margin-top: 2px;">
                  已生成分摊费用，如果删除了分摊费用，需要重新生成（去虚拟表计算（点击反审核，在点击审核，即可来当前界面在次分摊计算））
                </div>
              </div>
             </div>
           </div>
        </div>
        <!-- <v-divider></v-divider> -->
        <div style="margin-top: 5px;"></div>
        <!-- 列表 -->
        <div v-if="type==1">
          <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="ID" width="80"></el-table-column>
            <el-table-column prop="h_name" label="客户名称" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="charge_name" label="收费标准" width="170"></el-table-column>
            <el-table-column  label="计费周期" width="140">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="should_charge_date" label="应收日期" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="面积/用量" width="80"></el-table-column>
            <el-table-column prop="charge" label="应收金额" width="80"></el-table-column>
            <el-table-column prop="a_update_name" label="修改" width="80"></el-table-column>
            <el-table-column prop="a_check_name" label="审核" width="80"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <div style="color: blue;cursor: pointer;" @click="updateId(scope.row.id)">修改</div>
                  <div style="color: red;margin-left: 3px;cursor: pointer;" @click="del(scope.row.id)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages" v-if="desserts">
            <Page :total="total" :page-size="page" @on-change="change"  show-total />
          </div>
          <div class="zhanwu" v-else>没有数据</div>
        </div>
        <!-- 查看日记 -->
        <div v-if="type == 2">
          <el-table ref="multipleTable" :data="dessertsLog" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="错误原因"></el-table-column>
            <el-table-column prop="endDate" label="发生时间" width="150"></el-table-column>
          </el-table>
        </div>
        <!-- 查看汇总 -->
        <div v-if="type == 3">
          <el-table ref="multipleTable" :data="routineSum" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="收费项目" width="150"></el-table-column>
            <el-table-column  label="计费周期" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="应收日期" width="120"></el-table-column>
            <el-table-column prop="xsc_Amount" label="面积/用量" width="120"></el-table-column>
            <el-table-column prop="charge" label="应收金额" width="120"></el-table-column>
            <el-table-column prop="discount" label="减免金额" width="120"></el-table-column>
            <el-table-column prop="money" label="实际应收金额" width="120"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <Modal
      v-model="addmodel"
      width="950"
      title="应收款详细信息"
      okText="保存"
      :loading="loadingModal"
      @on-ok="orderAdd">
      <div>
          <div class="cdj_div">应收款明细信息，房产：{{data.homeName}}</div>
           <div class="cdj_table">
              <div class="cdj_display">
                <!-- 左 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>房产</div>
                    <div class="cdj_el-input">
                        <el-select
                            style="width:100%"
                            v-model="houesmoney.house_id"
                            class="search"
                            size="mini"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="可搜索房产/客户姓名"
                            :remote-method="remoteMethod"
                            :loading="loading">
                            <el-option
                              v-for="item in selectList"
                              :key="item.house_id"
                              :label="item.house"
                              :value="item.house_id">
                            </el-option>
                          </el-select>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系人</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.name" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费项目</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.xsc_ChargeItemID_id" style="width: 100%" clearable @change="chargeItem_names1" size="mini" placeholder="收费项目">
                        <el-option v-for="item in chargeitem_2" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收日期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:100%" v-model="houesmoney.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>虚拟表</div>
                    <div class="cdj_el-input">
                        <!-- <el-input size="mini" v-model="houesmoney.ybiaoleix" placeholder="可搜索房产/仪表编号"></el-input> -->
                        <el-select
                            style="width:100%"
                            v-model="houesmoney.ybiaoleix"
                            class="search"
                            size="mini"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="可搜索虚拟表名称/虚拟表编号"
                            :remote-method="remotemeter"
                            :loading="loading">
                            <el-option
                              v-for="item in meterList"
                              :key="item.id"
                              :label="item.dummy_meter_id"
                              :value="item.id">
                            </el-option>
                          </el-select>
                    </div>
                  </div>
                  <!-- <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>本次读数</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_CurrentReadDegree"></el-input>
                    </div>
                  </div> -->
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>单价</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Price"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.charge"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">已缴金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.PaidChargeSum" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免类型</div>
                    <div class="cdj_el-input">
                        <el-select v-model="houesmoney.discountType" style="width: 100%" clearable size="mini" placeholder="减免类型">
                          <el-option v-for="item in discount_type" :key="item.number" :label="item.name" :value="item.number"></el-option>
                        </el-select>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.chargePay"></el-input>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">备注</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.remark"></el-input>
                    </div>
                  </div>
                </div>
                <!-- 右 -->
                <div class="cdj_left">
                  <div class="cdj_left_display">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>客户名称</div>
                    <div class="cdj_el-input" style="display:flex;">
                        <el-input size="mini" v-model="houesmoney.h_name" :disabled="true"></el-input>
                        <el-button size="mini" style="margin-left:2px;" @click="user">选择</el-button>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">联系电话</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.phoen" :disabled="true"></el-input>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>收费标准</div>
                    <div class="cdj_el-input">
                      <el-select v-model="houesmoney.charge_id" style="width: 100%" clearable size="mini" placeholder="收费标准">
                        <el-option v-for="item in charges1" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>计费周期</div>
                    <div class="cdj_el-input el-date-pickers">
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.startDate" type="date" placeholder="开始时间"></el-date-picker>
                      <span style="margin-top: 3.5px;">至</span>
                      <el-date-picker size="mini" style="width:50%" v-model="houesmoney.endDate" type="date" placeholder="结束时间"></el-date-picker>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>使用度数</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_Amount"></el-input>
                    </div>
                  </div>

                 <!-- <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>上去读数</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.xsc_LastReadDegree"></el-input>
                    </div>
                  </div> -->
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">挂账金额</div>
                    <!-- <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.account"></el-input>
                    </div> -->
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red"></span></div>
                    <div class="cdj_el-input" style="margin-top: 31px;">
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red"></span></div>
                    <div class="cdj_el-input" style="margin-top: 31px;">
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background">减免金额</div>
                    <div class="cdj_el-input">
                        <el-input size="mini" v-model="houesmoney.discount"></el-input>
                    </div>
                  </div>

                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red"></span></div>
                    <div class="cdj_el-input" style="margin-top: 31px;">
                    </div>
                  </div>
                  <div class="cdj_left_display cdj_top">
                    <div class="cdj_left_display_background"><span style="color:red">*</span>应收标志</div>
                    <div class="cdj_el-input" style="margin-top: 3.5px;">
                      <el-radio v-model="houesmoney.chargePaySign" label="1">普通应收</el-radio>
                      <el-radio style="margin-left: -20px;" v-model="houesmoney.chargePaySign" label="2">调整应收</el-radio>
                    </div>
                  </div>
                </div>
              </div>
           </div>
      </div>
    </Modal>


    <!-- 修改计费时间 -->
    <Modal
      v-model="updateDateModel"
      width="700"
      title="修改计费时间"
      okText="开始修改"
      :loading="loadingModal"
      @on-ok="updateDateAdd">
      <div>
          <div class="cdj_div">修改计费的开始时间、结束时间、应收日期，房产：{{data.homeName}}</div>
           <div class="cdj_table" >
               <div class="cdj_left" style="width: 100%;">
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费开始时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.startDate" type="date" placeholder="开始时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">计费结束时间</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.endDate" type="date" placeholder="结束时间"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">应收日期</div>
                   <div class="cdj_el-input el-date-pickers">
                     <el-date-picker size="mini" v-model="updates.should_charge_date" type="date" placeholder="应收日期"></el-date-picker>
                   </div>
                 </div>
                 <div class="cdj_left_display cdj_top">
                   <div class="cdj_left_display_background">进度</div>
                   <div class="cdj_el-input">
                     <el-progress style="margin-top: 5px;" :text-inside="true" :stroke-width="20" :percentage="0"></el-progress>
                   </div>
                 </div>
                 <div style="margin-top: 7px;">
                   1、计费的开始日期、结束日期、应收日期是系统自动根据在收费标准设置中设置的参数进行推算出来的，但是实际费用的收取时间会有变化。<br>
                   2、利用本功能就可以重新批量修改这三个日期。<br>
                   3、如果重新执行了费用核算功能，则这些日期需要重新修改。<br>
                   4、最好先确认了计算出来的费用金额结果已经准确后在来修改。<br>
                   5、这些日期的修改不会影响核算的金额。<br>
                   6、新录入的开始日期和结束日期必须在已经结账过的费用日期之外。<br>
                   <span style="color:red;">7、请至少输入一个日期，如果没有输入日期，则表示不做修改。</span>
                 </div>
               </div>
          </div>
      </div>
    </Modal>


    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>



</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
export default {
  name: "FormsOweMoney",
  data () {
    return {
      type:1,
      updateDateModel:false,
      loadingModal:true,
      house:'',
      modal1:false,
      addmodel:false,
      routineSum:[],
      list_houesmoney:{
        user:'1',
        house_id:'',
        h_name:'',
        name:'',
        phoen:'',
        xsc_ChargeItemID_id:'',
        charge_id:'',
        should_charge_date:'',
        xsc_Price:'0',
        proportion:'1',
        sign:'2',
        account:'0.00',
        chargePaySign:'1',
        charge:'',
        PaidChargeSum:'0.00',
        discount:'0.00',
        discountType:'',
        xsc_Amount:1,
        remark:'',
        startDate:'',
        endDate:'',
        chargePay:'',
      },
      houesmoney:{
        id:'',
        house_id:'',
        h_name:'',
        name:'',
        phoen:'',
        xsc_ChargeItemID_id:'',
        charge_id:'',
        should_charge_date:'',
        xsc_Price:'',
        proportion:'1',
        sign:'2',
        account:'0.00',
        chargePaySign:'1',
        charge:'',
        PaidChargeSum:'0.00',
        discount:'0.00',
        discountType:'',
        xsc_Amount:'',
        remark:'',
        startDate:'',
        endDate:'',
        chargePay:'',
        ybiaoleix:'',
        xsc_CurrentReadDegree:'',
        xsc_LastReadDegree:'',
      },
      activeName: 'first',
      checkeds:'',
      checked:[],
      startDate:'',
      endDate:'',
      chargeitem:[],
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        house_id:'',
        homeName:'',
        startDate:'',
        endDate:'',
        chargeitemID:'',
        name:'',
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
        IsCheck:"1",
      },
      updates:{
        startDate:'',
        endDate:'',
        should_charge_date:'',
      },
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      charges1:[],
      charges2:[],
      selectList:[],
      discount_type:[],
      homeName:'',
      house:'',
      meterList:[],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.discount_type = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //搜索仪表（虚拟表）
    remotemeter(query){
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/ShareExpense/meter_text?text=" +query+"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.meterList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.meterList = [];
      }
    },

    //修改计费周期
    updateDate(){
      if(!this.data.pid){
        this.$Message.error("未选择房产");
      }else{
        this.updateDateModel = true;
      }
    },
    updateDateAdd(){
      let data = {'data':this.data,'update':this.updates}
      this.$myhttp.post('admin/ShareExpense/update_list',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 200){
            this.updateDateModel = false;
            this.change(1);
            this.$Message.success(backdata.data.message);
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //查看日记
    logs(){
      this.type=2;
    },
    //查看汇总
    sums(){
      this.type=3;
      this.dates();
      //ERP.showLoading()
      this.$myhttp.post('admin/ShareExpense/orderRoutineSum',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          if(backdata.data.code == 200){
            this.routineSum = data;
          }else{
            this.routineSum = [];
            //this.$Message.success(backdata.data.message);
          }
          //ERP.hideLoading()
      });
    },
    //新增
    add(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      if(this.houesmoney.id){
        this.houesmoney={
          id:'',
          house_id:'',
          h_name:'',
          name:'',
          phoen:'',
          xsc_ChargeItemID_id:'',
          charge_id:'',
          should_charge_date:'',
          xsc_Price:'',
          proportion:'1',
          sign:'2',
          account:'0.00',
          chargePaySign:'1',
          charge:'',
          PaidChargeSum:'0.00',
          discount:'0.00',
          discountType:'',
          xsc_Amount:'',
          remark:'',
          startDate:'',
          endDate:'',
          chargePay:'',
          ybiaoleix:'',
          xsc_CurrentReadDegree:'',
          xsc_LastReadDegree:'',
        };
      }
      this.addmodel = true;
    },
    //搜索房产
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/common/cdj_house_text?text=" +query +"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //选择客户
    user(){
      this.modal1 = true;
    },
    //点击客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
      this.houesmoney.h_name = this.developer.name;
    },
    //修改查询
    updateId(id){
      this.$myhttp.get("admin/ShareExpense/getUpdate?id="+id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          //console.log(backdata.data.data);
          this.houesmoney = backdata.data.data.order[0];
          this.selectList = backdata.data.data.house;
          this.charges1 = backdata.data.data.charge;
          this.developer = backdata.data.data.customer;
          this.addmodel = true;
      });
    },
    //点击收费项目
    chargeitem_types(){
      //临时费用收费项目
      this.$myhttp.get('admin/common/shareChargeitemName?pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_1 = backdata.data.data;
          this.chargeitem_2 = backdata.data.data;
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charge = backdata.data.data;
      });
    },
    chargeItem_names1(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney.chargeitemID = '';
          this.charges1 = backdata.data.data;
      });
    },
    chargeItem_names2(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.list_houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.list_houesmoney.chargeitemID = '';
          this.charges2 = backdata.data.data;
      });
    },
    //保存
    orderAdd(){
      let data = {'houesmoney':this.houesmoney,'developer':this.developer}
      this.$myhttp.post('admin/ShareExpense/add',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loadingModals();
          if(backdata.data.code == 200){
            this.addmodel = false;
            this.$Message.success(backdata.data.message);
            this.change(1);
            this.houesmoney={
              id:'',
              house_id:'',
              h_name:'',
              name:'',
              phoen:'',
              xsc_ChargeItemID_id:'',
              charge_id:'',
              should_charge_date:'',
              xsc_Price:'',
              proportion:'1',
              sign:'2',
              account:'0.00',
              chargePaySign:'1',
              charge:'',
              PaidChargeSum:'0.00',
              discount:'0.00',
              discountType:'',
              xsc_Amount:'',
              remark:'',
              startDate:'',
              endDate:'',
              chargePay:'',
              ybiaoleix:'',
              xsc_CurrentReadDegree:'',
              xsc_LastReadDegree:'',
            };
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },

    //全选
    // checkeds_list(){
    //   //console.log(this.checkeds)
    //   if(this.checkeds == true){
    //     this.checked={
    //       checked0:this.desserts[0].id,
    //       checked1:this.desserts[1].id,
    //       checked2:this.desserts[2].id,
    //       checked3:this.desserts[3].id,
    //       checked4:this.desserts[4].id,
    //       checked5:this.desserts[5].id,
    //       checked6:this.desserts[6].id,
    //       checked7:this.desserts[7].id,
    //       checked8:this.desserts[8].id,
    //       checked9:this.desserts[9].id,
    //       checked10:this.desserts[10].id,
    //       checked11:this.desserts[11].id,
    //     }
    //   }else{
    //     this.checked={
    //       checked0:"",
    //       checked1:"",
    //       checked2:"",
    //       checked3:"",
    //       checked4:"",
    //       checked5:"",
    //       checked6:"",
    //       checked7:"",
    //       checked8:"",
    //       checked9:"",
    //       checked10:"",
    //       checked11:"",
    //     }
    //   }
    // },
    handleSelectionChange(val) {
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
      let order = val;
      order.map((req,index)=>{
        if(index == 0){
          this.checked.checked0 = req.id;
        }
        if(index == 1){
          this.checked.checked1 = req.id;
        }
        if(index == 2){
          this.checked.checked2 = req.id;
        }
        if(index == 3){
          this.checked.checked3 = req.id;
        }
        if(index == 4){
          this.checked.checked4 = req.id;
        }
        if(index == 5){
          this.checked.checked5 = req.id;
        }
        if(index == 6){
          this.checked.checked6 = req.id;
        }
        if(index == 7){
          this.checked.checked7 = req.id;
        }
        if(index == 8){
          this.checked.checked8 = req.id;
        }
        if(index == 9){
          this.checked.checked9 = req.id;
        }
        if(index == 10){
          this.checked.checked10 = req.id;
        }
        if(index == 11){
          this.checked.checked11 = req.id;
        }
      })
    },
    //分摊计算
    list_add(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      this.$confirm('您确定要进行分摊费用计算吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        this.$myhttp.post('admin/ShareExpense/calculateMoneyAdd',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {
        ERP.hideLoading();
      });
    },
    //多条删除
    dels(){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //ERP.showLoading()
        this.$myhttp.post('admin/ShareExpense/setup_del',this.checked,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             //ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //全部删除
    lise_del(){
      if(!this.data.pid){
        this.$Message.error("点击左边树选择项目");
        return false;
      }
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //ERP.showLoading()
        this.$myhttp.post('admin/ShareExpense/del_list',this.data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             //ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //获得当前多少页,分页
    change(e){
      this.type = 1;
      this.dates();
      //ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/ShareExpense/orderExpense',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          //ERP.hideLoading()
      });
      this.checkeds = false;
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
    },
    //时间转换
    dates(){
      this.data.startDate = '';
      this.data.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
      this.chargeitem_types();
    },
    //删除
    del(id){
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        let ids = {'id':id};
        this.$myhttp.post('admin/TemporaryExpense/del',ids,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
             ERP.hideLoading()
             if(backdata.data.code == 200){
               this.change(1);
               this.$Message.success(backdata.data.message);
             }else{
               this.$Message.error(backdata.data.message);
             }
        });
      }).catch(() => {

      });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },
  },
  watch:{
    // 'houesmoney.charge'(val){
    //     this.houesmoney.chargePay = this.houesmoney.charge
    // }
  },
  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/expense/ShareExpense.vue